import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

class Career extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h1 className="title-a">Career</h1>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <VerticalTimeline className="vertical-timeline">
              <VerticalTimelineElement
                date="Sept 2025 - Present"
                dateClassName="vertical-timeline-element-date"
                icon={<FontAwesomeIcon icon={faBriefcase} />}
              >
                <h4 className="vertical-timeline-element-title">Wilson Tool International Ltd.</h4>
                <h5 className="vertical-timeline-element-subtitle">Software Engineer</h5>
                <div className="career-vertical-timeline-element-content">
                  Promoted to Software Engineer after 2-year industrial placement.
                  <ul>
                    <li>Designed and deployed scalable backend and full-stack systems automating end-to-end production workflows across 5+ manufacturing lines, removing manual bottlenecks and increasing process reliability.
                    </li>
                    <li>Led modernisation of legacy platforms by rebuilding data pipelines, restructuring backend logic, and improving system architecture, contributing to a documented 35% uplift in operational efficiency.
                    </li>
                    <li>Collaborated with production, engineering, and operations teams to diagnose system issues and deliver monitoring and workflow optimisation solutions, improving processing speed, data integrity, and supporting real-time production insights on the shop floor.

                    </li>
                  </ul>
                </div>


              </VerticalTimelineElement>

              <VerticalTimelineElement
                date="Aug 2023 - Aug 2025"
                dateClassName="vertical-timeline-element-date"
                icon={<FontAwesomeIcon icon={faBriefcase} />}
              >
                <h5 className="vertical-timeline-element-title">Wilson Tool International Ltd.</h5>
                <h4 className="vertical-timeline-element-subtitle">Software Engineer Intern - Industrial Placement</h4>
                <div className="career-vertical-timeline-element-content">
                  <ul>
                    <li>Developed predictive pricing  models using R and Minitab, applying statistical analysis to historical tooling data, achieving 98% pricing accuracy and reducing quotation variance.
                    </li>
                    <li>Built multi-source data ingestion and automation  tools  supporting £32M in annual operational decision-making.
                    </li>
                    <li>Engineered a C# WPF application with SQL Server and API integration, supported by Git-based CI/CD pipelines automating data collection, analysis, and visualisation, eliminating 20 minutes of manual checks per shift.</li>
                    <li>Delivered cross-platform tools (React Native, Electron, TypeScript) used by 100+ engineers and customers globally, improving access to real-time production information, standardising calculation and terminology.
                    </li>
                    <li>Integrated Arduino sensor systems with Outlook (Visual Basic), enabling automated alerts and reducing downtime.</li>
                  </ul>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                date="Dec 2024 - June 2025"
                icon={<FontAwesomeIcon icon={faBriefcase} />}
              >
                <h4 className="vertical-timeline-element-title">University of West of England</h4>
                <h5 className="vertical-timeline-element-subtitle">Student Accessibility Support Lead</h5>
                <div className="career-vertical-timeline-element-content">
                  <ul>
                    <li>Selected by module and programme leader to provide dedicated 1:1 academic support for a visually impaired cohort member.
                    </li>
                    <li>Designed and managed a personalised support plan, coordinating with faculty and student services to remove barriers to learning.
                    </li>
                  </ul>
                </div>
              </VerticalTimelineElement>



              <VerticalTimelineElement
                date="Oct 2024 - June 2025"
                icon={<FontAwesomeIcon icon={faBriefcase} />}
              >
                <h4 className="vertical-timeline-element-title">University of West of England</h4>
                <h5 className="vertical-timeline-element-subtitle">Student Representative</h5>
                <div className="career-vertical-timeline-element-content">
                  <ul>
                    <li> Acted as a liaison between students and the department. </li>
                    <li>  Represented student feedback to faculty and programme staff. </li>
                    <li> Participated in meetings to improve course delivery and student experience. </li>
                  </ul>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                date="June 2022 - Aug 2022"
                icon={<FontAwesomeIcon icon={faBriefcase} />}
              >
                <h4 className="vertical-timeline-element-title">Care4Calais</h4>
                <h5 className="vertical-timeline-element-subtitle">Volunteer</h5>
                <div className="career-vertical-timeline-element-content">

                  Coordinated games and activities for groups of 15+ refugee children to build their confidence and support their English learning, completing safeguarding training to ensure safe engagement.


                </div>
              </VerticalTimelineElement>


              <VerticalTimelineElement
                date="Sept 2021 - Aug 2025"
                icon={<FontAwesomeIcon icon={faGraduationCap} />}
              >
                <h4 className="vertical-timeline-element-title">University of West of England</h4>
                <h5 className="vertical-timeline-element-subtitle">BSc (Hons) Computer Science</h5>
                <div className="career-vertical-timeline-element-content">
                  1st Class Degree<br />
                  <span className="fw-bold">Women’s Football Team Member: </span>Represented the university in competitive fixtures alongside full-time study.<br />
                  <span className="fw-bold">Relevant Modules:</span> Databases, AI, Web & Mobile Development, IoT, Operating Systems, Embedded Systems…<br />
                </div>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                date="Sept 2020 - Sept 2021"
                icon={<FontAwesomeIcon icon={faGraduationCap} />}
              >
                <h4 className="vertical-timeline-element-title">Gebze Technical University</h4>
                <h5 className="vertical-timeline-element-subtitle">BEng Electronic Engineering</h5>
                <div className="career-vertical-timeline-element-content">
                  CGPA: 3.23 <br />
                  <span className="fw-bold">Community Involvement:</span> Engaged in IEEE Student Community projects, enhancing technical skills through
                  hands-on activities and peer-led engineering sessions.  <br />
                  <span className="fw-bold">Relevant Modules:</span> Algorithms and Programming, Linear Algebra, Mathematics…
                </div>
              </VerticalTimelineElement>
            </VerticalTimeline>
          </div>
        </div>
      </div>
    );
  }
}

export default Career;